/**
 * @module app.cm
 */

import { autoinject, transient } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IQueryLoadOptions, IApiQueryResults } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { Toaster } from 'app/shared/lib/toaster';
import { ApiQuery } from 'app/shared/lib/essette-api';
import * as AG from 'app/ag/models/essette-api';

@transient()
@autoinject()
export class CaseService {

    ////****************** Functions ************************************************////
    constructor(
        private readonly api: Api,
        private readonly env: EnvironmentService,
        private readonly logger: AppLogger,
        private readonly toaster: Toaster) {

        this.logger.source = this;
    }

    public async get<T>(query: ApiQuery): Promise<IApiQueryResults<T>> {
        return await this.api.get(query) as IApiQueryResults<T>;
    }


    ////****************** Settings *************************************************////


    ////****************** Queries **************************************************////
    public async loadCasesByMember(memberId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<AG.Case>> {
        const query = this.api
            .query('ag/cases/')
            .filterIdentifier('member.id', memberId)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);
        return await this.api.get(query);
    }

    ////****************** Loads ****************************************************////
    public async loadCaseTypes(options?: Partial<IQueryLoadOptions>, includes: string[] = []): Promise<IApiQueryResults<AG.CaseType>> {
        const query = this.api
            .query('ag/cases/types')
            .applyStandardLoadOptions(options)
            .include(...includes);
        return await this.api.get(query);
    }

    public async loadRequestMethods(options?: Partial<IQueryLoadOptions>, includes: string[] = []): Promise<IApiQueryResults<AG.RequestMethod>> {
        const query = this.api
            .query('ag/requests/methods')
            .applyStandardLoadOptions(options)
            .include(...includes);
        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////

}

